// extracted by mini-css-extract-plugin
export default {"arrivals":"Arrivals_arrivals__hREAq","arrivals__btn-group":"Arrivals_arrivals__btn-group__WCWBN","arrivals__details":"Arrivals_arrivals__details__DfxAN"};